import isLink from '../../content-editable/verifiers/is-link';
import constants from '../constants';
import getFallbackConfig from './get-fallback-config';

const getLinkConfig = (node) => {
  // It's needed for creating link in text-formatting extension
  if (!node) {
    return {
      linkType: constants.linkTypes.EXTERNAL,
      reference: '#',
    };
  }

  if (!isLink(node)) {
    throw new Error('Node should be "a" tag');
  }

  if (node.hasAttribute(constants.common.LINK_CONFIG_ATTRIBUTE)) {
    return JSON.parse(node.getAttribute(constants.common.LINK_CONFIG_ATTRIBUTE));
  }

  const config = getFallbackConfig(node);

  if (
    config.linkType === constants.linkTypes.EXTERNAL ||
    config.linkType === constants.linkTypes.PATH
  ) {
    if (node.getAttribute('target') === constants.common.BLANK) {
      config.target = constants.common.BLANK;
    }
  }

  return config;
};

export default getLinkConfig;
